import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

const DIGITS = /\d/g;

/**
 * One way to show a phone number everywhere: international format with
 * spaces, "+1 206 909 7463". A number that cannot be read comes back as
 * typed, so nothing is ever hidden. A bare ten-digit number is read as North
 * American, which is where nearly all stored numbers without a country code
 * come from.
 */
export function formatPhone(value: string | null | undefined): string {
  const raw = (value ?? '').trim();
  return read(raw)?.formatInternational() ?? raw;
}

/** The dialable form, "+12069097463", for tel: links and copy. */
export function dialablePhone(value: string | null | undefined): string {
  const raw = (value ?? '').trim();
  return read(raw)?.number ?? raw;
}

function read(raw: string) {
  if (!raw) return undefined;
  const parsed = parsePhoneNumberFromString(raw);
  if (parsed) return parsed.isPossible() ? parsed : undefined;
  // isPossible only checks the length, so the North American guess must be a
  // real number: "0412 345 678" is an Australian mobile, not +1 041 234 5678.
  if ((raw.match(DIGITS) ?? []).length !== 10) return undefined;
  const us = parsePhoneNumberFromString(raw, 'US');
  return us?.isValid() ? us : undefined;
}
